<template>
  <div>
    <Header />

    <main class="app-content">
      <div class="app-title">
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#/giderkayit">SAHALAR</a></li>
        </ul>
      </div>
      <div style="margin:auto" aria-labelledby="navbarDropdown">
        <!-- <input class="form-control py-2 border-left-0 border" type="search" value="..." id="example-search-input"> -->
        <input class="form-control py-2 border-left-0 border" style="width:1000px;border-radius:0.25rem" type="search"
          v-model="searchString" placeholder="ARATMAK İSTEDİĞİNİZ KELİMEYİ GİRİNİZ" />
        <div style="width: 1000px;position: absolute; z-index:1;">
          <ul class="searchCss" style="">
            <li v-for="result in results" :key="result.id">
              <hr />
              <div @click="routeDetail(result)"
                style="padding-right: 5px;padding-left: 5px;font-size: 15px;color: black;">

                {{ result.sahaId + "~~~" + result.tutar + "₺" + "~~~" + result.date + "~~~" + result.aciklamaone }}

              </div>
            </li>
          </ul>
        </div>
      </div>
      <br>

      <div class="row">
        <div class="col-lg-12 col-md-12 rowHomepage" style="display: -webkit-box">
          <div v-for="(item, index) in sahalar" :key="index" class="col-md-3 col-lg-3"
            style="margin-bottom: 22px; height:110px" v-if="sahalar[index].status == 0">
            <div style="
            background-color: rgb(90, 174, 158);
            display: flex;
            justify-content: center;
            align-items: center;
          " class="tileHomepage">
              <div class="about-content">
                <div>
                  <p v-if="
                    sahalar[index].isyuzdesi <= 25 &&
                    sahalar[index].isyuzdesi >= 0
                  " @click="routePage(item)" id="kirmizi">
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%

                  </p>
                  <p v-if="
                    sahalar[index].isyuzdesi <= 55 &&
                    sahalar[index].isyuzdesi >= 26
                  " @click="routePage(item)" id="turuncu">
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="
                    sahalar[index].isyuzdesi <= 75 &&
                    sahalar[index].isyuzdesi >= 56
                  " @click="routePage(item)" id="sari">
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="
                    sahalar[index].isyuzdesi <= 99 &&
                    sahalar[index].isyuzdesi >= 76
                  " @click="routePage(item)" id="yesil">
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                  <p v-if="
                    sahalar[index].isyuzdesi >= 100
                  " @click="routePage(item)" id="mavi">
                    {{ sahalar[index].sahaName }} -
                    {{ sahalar[index].isyuzdesi }}%
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import { debounce } from "lodash";
export default {
  data() {
    return {
      searchString: "",
      results: [],
      product: [],

      sahalar: [],
      nowdate: "",
      nowyear: "",
      nowmonth: "",
      getFullYearAll: "",
    };
  },
  watch: {
    searchString: debounce(function () {
      this.search();
    }, 250),
    $route() {
      $("#navbarSupportedContent").collapse("hide");
    },
  },
  methods: {
    async getFilteredUsers() {
      const filteredUsers = await fetch(
        ' https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/getAllGider.php'
      );
      this.users = await filteredUsers.json();
    },
    search: function () {
      if (this.searchString.length > 0) {
        axios
          .get(
            `https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/searchProduct.php?key=123&keyword=${this.searchString}`
          )
          .then((response) => {
            var deger = response.data.length;
            if (deger > 50) {
              this.results = response.data.slice(0, 50);
            } else {
              this.results = response.data;
            }
          });
      } else {
        this.results = null;
      }
    },
    routePage: function (item) {
      window.location.href = "#/studentsdetail?id=" + item.id;
    },
    routeDetail: function (item) {
      window.location.href = "#/updategider?id=" + item.id;
    },
  },
  mounted() {
    let date = new Date();
    this.nowdate = date.getDate()
    this.nowyear = date.getFullYear()
    this.nowmonth = date.getMonth()
    this.getFullYearAll = this.nowdate + "." + this.nowmonth + "." + this.nowyear;
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "AslanSahalar/getAllSaha.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.sahalar = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });

    setTimeout(function () {
      window.location.reload(1);
    }, 2500000);
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>

<style>
#kirmizi {
  border-radius: 15px 50px;
  text-align: center;
  font-size: 25px;
}

#turuncu {
  border-radius: 15px 50px;
  text-align: center;
  font-size: 25px;
}

#sari {
  border-radius: 15px 50px;
  text-align: center;
  font-size: 25px;
}

#yesil {
  border-radius: 15px 50px;
  text-align: center;
  font-size: 25px;
}

#mavi {
  border-radius: 15px 50px;
  text-align: center;
  font-size: 25px;
}

#pid1:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}

#pid2:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}

#pid3:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}

#pid4:hover {
  border-radius: 15px 50px;
  background-color: #63ca92;
  text-align: center;
  font-size: 25px;
}

.searchCss {
  border-radius: 6px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Students.vue